export default __webpack_public_path__ + "static/media/three-dots.c795f4c1.svg";